<template>
    <div>

        <!-- banner -->
        <div class="banner">

            <div class="banner-center">
                <div class="textbox">
                    <div class="banner-text1">远程异地评标和评标专家库共享技术标准</div>
                    <div class="banner-text2">助力建设全国统一大市场，优化市场营商环境</div>
                </div>

                <div>
                    <img src="../assets/img/banner2/11-2.png" alt="" class="banner-img">
                </div>
            </div>


        </div>









        <!-- 政策文件 -->
        <div class="box0">


            <mytitle title="政策文件"></mytitle>

            <div class="center" style="position: relative;">

                <div class="delStep" style="position: absolute; left: -50px;top: 160px;" @click="prevCarousel">
                    <img src="../assets/img/delstep.svg" alt="" style="width: 16px;height: 16px;">
                </div>

                <div class="delStep" style="position: absolute; right: -50px;top: 160px;" @click="nextCarousel">
                    <img src="../assets/img/addstep.svg" alt="" style="width: 16px;height: 16px;">

                </div>

                <el-carousel indicator-position="none" style="width: 100%;margin-top: 72px;" arrow="never"
                    ref="myCarousel">
                    <el-carousel-item v-for="(item, index) in fileList" :key="index">
                        <div class="filebox">
                            <div class="filebox-item">
                                <div class="fileImg">
                                    <img :src=item[0].img alt="" style="width: 120px;height: 160px;">
                                </div>
                                <div class="fileContent">
                                    <div class="fileTitle">{{ item[0].title }}</div>
                                    <div class="fileText">{{ item[0].text }}
                                    </div>
                                    <div class="tofile" @click="tofile(item[0].url

                                    )">了解详情</div>

                                </div>
                            </div>

                            <div class="filebox-item">
                                <div class="fileImg">
                                    <img :src=item[1].img alt="" style="width: 120px;height: 160px;">
                                </div>
                                <div class="fileContent">
                                    <div class="fileTitle">{{ item[1].title }}</div>
                                    <div class="fileText">{{ item[1].text }}
                                    </div>
                                    <div class="tofile" @click="tofile(item[1].url

                                    )">了解详情</div>

                                </div>
                            </div>





                        </div>

                    </el-carousel-item>
                </el-carousel>


            </div>




        </div>

        <!-- 政策背景 -->
        <div class="box1">


            <mytitle title="政策背景" style="margin-top: 64px;"></mytitle>


            <div class="bigcenter" style="position: relative;">

                <div class="delStep" style="position: absolute; left: -55px;top: 278px;" @click="delstep">
                    <img src="../assets/img/delstep.svg" alt="" style="width: 16px;height: 16px;">

                </div>

                <div class="delStep" style="position: absolute; right: -55px;top: 278px;" @click="addstep">
                    <img src="../assets/img/addstep.svg" alt="" style="width: 16px;height: 16px;">

                </div>

                <div class="center" ref="parentRef">




                    <div class="stepBox" v-for="(item, index) in yearList" :key="index"
                        :style="{ transform: `translateX(${-scrollOffset}px)` }">
                        <div class="stepLine1"
                            :style="{ backgroundColor: nowStep >= item.year ? ' #2544B3' : '#D6DBE3', }"></div>
                        <div class="step">
                            <div class="yearInfoBox2" v-if="index % 2 === 0">
                                <!-- <div class="title"
                                    :style="{ width: index === 6 ? '70%' : '90%', marginLeft: index === 6 ? '35px' : '7px' }">
                                    {{ item.title }}</div> -->
                                <div class="title">{{ item.title }}</div>
                                <!-- <div class="text">{{ item.text }}</div> -->
                                <div class="text" v-html="item.text"></div>
                            </div>

                            <div class="yearInfoBox" v-else>
                                <div class="title">{{ item.title }}</div>
                                <!-- <div class="text">{{ item.text }}</div> -->
                                <div class="text" v-html="item.text"></div>

                            </div>
                            <div class="year">{{ item.year }}</div>

                            <div class="steppoint2">
                                <img src="../assets/img/introduction/nowStep.svg" alt="" v-if="nowStep == item.year">
                                <img src="../assets/img/introduction/step.svg" alt="" style="width: 12px;height: 12px;"
                                    v-else>
                            </div>






                            <div class="nowStep" v-if="nowStep == item.year">
                                <img src="../assets/img/introduction/nowStep2.svg" alt="">
                            </div>
                        </div>
                        <div class="stepLine1"
                            :style="{ backgroundColor: nowStep > item.year ? ' #2544B3' : '#D6DBE3' }"></div>
                    </div>

                </div>

            </div>



        </div>


        <div>
            <!-- 简介 -->

            <div class="box2">
                <mytitle title="远程异地评标和评标专家库共享简介" color="white" style="margin-top: 64px;"></mytitle>
                <div class="center">

                    <div class="textbox">
                        <img src="../assets/img/introduction/Vector.png" alt="" class="textico">
                        <div class="text-item">
                            基于中国招标投标公共服务平台、各省级招标投标公共服务平台、电子招标投标监督系统、电子招标投标交易系统、电子评标专业工具、场所运行管理系统、场所工位预约工具、专家库管理系统、会议交流工具等共建、共治、共享的公共网络服务体系，通过共享目录和“点对点”互联机制，实现专家库资源、评标场地资源和场地音视频互联互通。
                        </div>

                    </div>
                    <div class="textbox">
                        <img src="../assets/img/introduction/Vector.png" alt="" class="textico">
                        <div class="text-item">
                            为推进远程异地评标便捷、高效开展，需要以电子招标采购网络为基础，进一步拓展延伸建立专家库、评标场地、音视频等互联网络体系，实现专家库资源、评标场地资源和场地音视频互联互通。实现以经营主体为中心，按需抽取专家、自主预订场地，专家通过视频会议实时在线交流，监督人员全程实时在线监督。
                        </div>


                    </div>

                </div>


            </div>

            <div>

                <!-- 技术标准 -->
                <!-- <section class="gray">
        <mytitle title="技术标准"></mytitle>
        <main class="list-main">
          <template v-for="(item, index) in standards" :key="index">
            <StandardCard :title="item.title" :desc="item.desc" @preview="previewGuide(item)"
              @download="downloadGuide(item)" />
          </template>
</main>
</section> -->
            </div>



            <div>
                <!-- 接入指南 -->
                <section>
                    <mytitle title="接入指南"></mytitle>
                    <main class="list-main">
                        <template v-for="(item, index) in guides" :key="index">
                            <StandardCard :title="item.title" @preview="previewGuide(item)"
                                @download="downloadGuide(item)" />
                        </template>
                    </main>
                </section>
            </div>



        </div>
        <div>

        </div>
    </div>
</template>

<script lang='ts' setup>
import { reactive, toRefs, ref, onMounted } from 'vue'
import mytitle from '../components/title.vue'
import { useRouter } from "vue-router";
// import { getNews } from '../utils/axios/index2.ts'
import StandardCard from '../components/standard/standard-card'
import { getRemoteBidEvaluationDocument, newEndpointDownload } from '../utils/axios/index.js'
import { ElMessage } from 'element-plus'

import { getStandard, getNews, getEndpointCount } from '../utils/axios'
//文件轮播
const myCarousel = ref(null);

// 上一个
const prevCarousel = () => {
    if (myCarousel.value) {
        myCarousel.value.prev();
    }

}
// 下一个
const nextCarousel = () => {
    if (myCarousel.value) {
        myCarousel.value.next();
    }

}


//文件图片
import fileImg from '../assets/img/introduction/file-img0.png'

import fileImg1 from '../assets/img/introduction/file-img1.png'
import fileImg2 from '../assets/img/introduction/file-img2.png'

// 技术标准
const guides = ref([
    { title: '远程异地评标技术标准<br>电子交易系统接入指南', type: 1, name: 'S01远程异地评标和评标专家库共享技术标准_电子交易系统接入指南_20250605_1600' },
    
    { title: '远程异地评标技术标准<br>电子评标工具接入指南', type: 2, name: 'S02远程异地评标和评标专家库共享技术标准_电子评标工具接入指南_20250605_1600' },

    { title: '远程异地评标技术标准<br>场地视频会议系统接入指南', type: 5, name: 'L02远程异地评标和评标专家库共享技术标准_场地视频会议系统接入指南_20250605_1600' },


    { title: '远程异地评标技术标准<br>场地管理系统接入指南', type: 3, name: 'S03远程异地评标和评标专家库共享技术标准_场地管理系统接入指南_20250605_1600' },

    { title: '远程异地评标技术标准<br>场地音视频监控工具接入指南', type: 4, name: 'S04 远程异地评标和评标专家库共享技术标准_场地音视频监控工具接入指南_20250605_1600' },

    { title: '远程异地评标技术标准<br>专家库管理系统接入指南', type: 6, name: 'S05远程异地评标和评标专家库共享技术标准_专家库管理系统接入指南_20250605_1600' },

    { title: '远程异地评标技术标准<br>专家抽取终端接入指南', type: 7, name: 'S09远程异地评标和评标专家库共享技术标准_专家抽取终端接入指南_20250605_1600' },


])

// 技术标准展示数据
const standards = ref([
    {
        title: '远程异地评标<br>服务规范',
        type: 13,
        desc: {
            title: '面向各类平台、系统的运营方，在服务内容及使用流程',
            texts: [
                '规定远程异地评标的标准术语和定义',
                '基本原则',
                '远程异地评标架构',
                '服务内容与要求',
            ]
        }
    },
    {
        title: '远程异地评标<br>技术规范',
        type: 14,

        desc: {
            title: '面向各类平台、系统的运营方，在技术路线和功能实现',
            texts: [
                '规定远程异地评标的功能要求',
                '交互接口设计要求',
                '非功能性技术要求',
                '运行环境要求',
            ]
        }
    },
    {
        title: '远程异地评标<br>数据规范',
        type: 15,

        desc: {
            title: '面向跨应用数据共享方，在数据交互',
            texts: [
                '规定了电子交易系统、电子评标工具、场所运行管理系统、会议系统、环境音视频监控工具对接实现远程异地评标的数据要求',

            ]
        }
    },

    {
        title: '评标专家库共享<br>服务规范',
        type: 16,
        desc: {
            title: '面向专家库管理系统运营方，在服务内容及使用流程',
            texts: [
                '规定网络互联共享评标专家库的标准术语和定义',
                '基本原则',
                '网络互联共享评标专家库架构',
                '服务内容与要求',
            ]
        }
    },
    {
        title: '评标专家库共享<br>技术规范',
        type: 17,
        desc: {
            title: '面向专家库管理系统运营方，在技术路线和功能实现',
            texts: [
                '规定网络互联共享评标专家库的功能要求',
                '交互接口设计要求',
                '非功能性技术要求',
                '运行环境要求',
            ]
        }
    },
    {
        title: '评标专家库共享<br>数据规范',
        type: 18,
        desc: {
            title: '面向跨应用数据共享方，在数据交互',
            texts: [
                '规定了专家库管理系统对接实现网络互联共享评标专家库的数据要求',

            ]
        }
    },
])
//文件列表

let fileList = ref([
    [
        { title: '发改办法规〔2021〕24号', text: '《国务院关于开展营商环境创新试点工作的意见》', url: 'https://www.gov.cn/zhengce/content/202405/content_6949845.htm', img: fileImg1 },

        { title: '发改办法规〔2023〕54号', text: '《国家发展改革委关于在部分地方公共资源交易平台和企业招标采购平台试运行招标投标领域数字证书跨区域兼容互认功能的通知》', url: 'https://zfxxgk.ndrc.gov.cn/web/iteminfo.jsp?id=20445', img: fileImg2 },
    ],


])
const parentRef = ref(null);

// 滚动偏移量  
const scrollOffset = ref(0);
//当前年份
let nowStep = ref(2013)

//下一个年份

const addstep = () => {

    let now = {}
    yearList.value.map((element, index) => {
        if (element.year == nowStep.value) {
            if (index + 1 < yearList.value.length) {
                now = yearList.value[index + 1]
            }
            if (scrollOffset.value < 0) {
                scrollOffset.value += 240;

            }



        }
    });

    if (now.year) {
        nowStep.value = now.year
    }



}
//上一个年份

const delstep = () => {
    yearList.value.map((element, index) => {
        if (element.year == nowStep.value) {
            if (index - 1 >= 0) {
                nowStep.value = yearList.value[index - 1].year
            }
            if (scrollOffset.value > 2) {
                scrollOffset.value -= 240;
            }


        }
    });
}


//年份信息
let yearList = ref([




    { year: 2013, title: '首次提出设立专家库，实现专家资源共享', text: '《电子招标投标办法》（20号令）提出：公共服务平台要连接依法设立的评标专家库，实现专家资源共享。随后多次在政策中提出要推广远程异地评标，要求越加明确。' },
    { year: 2019, title: '通过远程异地评标推动专家资源跨地区、跨行业共享', text: '《关于深化公共资源交易平台整合共享的指导意见》（41号文）要求健全公共资源交易平台系统，通过远程异地评标、评审等方式加快推动优质专家资源跨地区、跨行业共享，优化专家抽取服务。' },
    { year: 2020, title: '完善远程异地评标系统及\n' + '技术规范', text: '国家发展改革委下发的《关于积极应对疫情创新做好招投标工作保障经济平稳运行的通知》，明确提出“积极推广电子评标和远程异地评标”，要求“各地要加快建设完善电子评标系统，应用信息化工具辅助评标，提高评标效率；完善远程异地评标系统及技术规范，尽早实现省内常态化运行，并为跨省运行创造条件，有效减少评标人员聚集，实现有限专家资源充分共享”。' },

    { year: 2022, title: '积极推广网络远程异地评标', text: '国家发展改革委下发《国家发展改革委等部门关于严格执行招标投标法规制度进一步规范招标投标主体行为的若干意见》提到严格规范和优化评标组织方式。积极推广网络远程异地评标，打破本地评标专家“小圈子”，推动优质专家资源跨省市、跨行业互联共享。' },

    { year: 2024, title: '全面推广远程异地评标', text: '国务院办公厅下发《关于创新完善体制机制推动招标投标市场规范健康发展的意见》，全面推广网络远程异地评标。推行隐藏投标人信息的暗标评审。积极试行投标人资格、业绩、信用等客观量化评审，提升评标质量效率。' },


])

//文字加粗
yearList.value.forEach(item => {
    // 使用正则表达式找到所有被《》包围的文本（包括书名号）  
    // const regex = /(《([^《》]*)》)/g;
    const regex = /\（(.*?)\）|《(.*?)》/g;

    // 替换匹配到的文本（包括书名号）为带有加粗样式的HTML  
    item.text = item.text.replace(regex, (match, p1) => `<span style="color: #323335;font-weight: 600;">${match}</span>`);
});









const router = useRouter();

const tonews = () => {
    // router.push({ path: '/news' })
}
//to新闻详情
const tonewslink = (url) => {
    // window.open(url, '_blank');
}
// 互认概览统计数量
let allNum = ref({
    appCount: 0,
    caOrgCount: 0,
    platformCount: 0,
    sealOrgCount: 0,
})

onMounted(() => {

    // //获取新闻列表
    // getNews({}).then(res => {
    //     newsList.value = res.data.records


    // }).catch(err => {

    // })

    // // 互认概览统计数量

    // getEndpointCount({}).then(res => {
    //     allNum.value = res.data
    //     // let nowUrl = window.location.href
    //     // if (nowUrl.includes('cashare.cebpubservice.com')) {
    //     //     //生产环境置空
    //     //     allNum.value.platformCount = 0
    //     // }

    // }).catch(err => {

    // })

})

let newsList = ref([{ newsTitle: '国家发展改革办公厅等关于展开工程建设招标投标领域突出问题专项治理的通知', publishTime: '2024-07-11' }])




let nowfile = ref(1)

//跳转文件地址

const tofile = (url) => {

    window.open(url, '_blank');

}

// 预览 
const previewGuide = (item: any) => {
    // getRemoteBidEvaluationDocument({ documentType: item.type }).then(res => {
    //     if(!res.data.documentUrl){
    //         ElMessage.warning('功能开发中，敬请期待！')
    //     }
    //     window.open(res.data.documentUrl, '_blank');

    // }).catch(res => {
    //     ElMessage.warning('功能开发中，敬请期待！')
    // })
    // window.open('远程异地评标和评标专家库共享技术标准_专家库管理系统和专家抽取终端接入指南.pdf', '_blank');
    // console.log(item.name);
    if (item.type == '1') {
        window._czc.push(['_trackEvent', '技术标准简介', '预览', '电子交易系统接入指南预览'])
    }
    if (item.type == '2') {
        window._czc.push(['_trackEvent', '技术标准简介', '预览', '电子评标工具接入指南预览'])
    }
    if (item.type == '3') {
        window._czc.push(['_trackEvent', '技术标准简介', '预览', '场地视频会议系统接入指南预览'])
    }
    if (item.type == '4') {
        window._czc.push(['_trackEvent', '技术标准简介', '预览', '场地管理系统接入指南预览'])
    }
    if (item.type == '5') {
        window._czc.push(['_trackEvent', '技术标准简介', '预览', '场地音视频监控工具接入指南预览'])
    }
    if (item.type == '6') {
        window._czc.push(['_trackEvent', '技术标准简介', '预览', '专家库管理系统和专家抽取终端接入指南预览'])
    }
    if (item.type == '7') {
        window._czc.push(['_trackEvent', '技术标准简介', '预览', '集成专家库共享抽取工具指南预览'])
    }
    window.open(item.name + '.pdf', '_blank');

   

}


// 下载 
const downloadGuide = (item: any) => {
    // let name2 = ''
    // getRemoteBidEvaluationDocument({ documentType: item.type }).then(res => {
    //     if(!res.data.documentUrl){
    //         ElMessage.warning('功能开发中，敬请期待！')
    //     }
    //     name2 = res.data.documentName
    //     let url = res.data.name
    //     newEndpointDownload({ contentDisposition: 'attachment', filePath: url }).then(res => {
    //         var blob = new Blob([res])
    //         let fname = name2 + '.pdf'; //下载文件的名字
    //         if (window.navigator && window.navigator.msSaveOrOpenBlob) {
    //             window.navigator.msSaveOrOpenBlob(blob, fname);
    //         } else {
    //             let objectUrl = URL.createObjectURL(blob);
    //             let link = document.createElement("a");
    //             link.href = objectUrl;
    //             link.setAttribute("download", fname);
    //             document.body.appendChild(link);
    //             link.click();
    //         }
    //     })



    // }).catch(res => {
    //     ElMessage.warning('功能开发中，敬请期待！')
    // })

    const a = document.createElement('a')
    a.href = item.name + '.pdf'
    a.download = item.name + '.pdf'
    a.click()



    if (item.type == '1') {
        window._czc.push(['_trackEvent', '技术标准简介', '下载', '电子交易系统接入指南下载'])
    }
    if (item.type == '2') {
        window._czc.push(['_trackEvent', '技术标准简介', '下载', '电子评标工具接入指南下载'])
    }
    if (item.type == '3') {
        window._czc.push(['_trackEvent', '技术标准简介', '下载', '场地视频会议系统接入指南下载'])
    }
    if (item.type == '4') {
        window._czc.push(['_trackEvent', '技术标准简介', '下载', '场地管理系统接入指南下载'])
    }
    if (item.type == '5') {
        window._czc.push(['_trackEvent', '技术标准简介', '下载', '场地音视频监控工具接入指南下载'])
    }
    if (item.type == '6') {
        window._czc.push(['_trackEvent', '技术标准简介', '下载', '专家库管理系统和专家抽取终端接入指南下载'])
    }
    if (item.type == '7') {
        window._czc.push(['_trackEvent', '技术标准简介', '下载', '集成专家库共享抽取工具指南下载'])
    }






}


</script>
<style lang="scss" scoped>
.banner {
    width: 100%;
    height: 577px;
    position: relative;
    background: url('../assets/img/banner2/11-1.png') no-repeat center center;
    background-size: cover;


    .banner-center {
        width: 1200px;
        position: absolute;
        left: 50%;
        transform: translate(-50%);
        display: flex;
        justify-content: space-between;
        top: 116px;

    }


    .textbox {
        display: flex;
        flex-direction: column;
        justify-content: center;
    }

    .banner-img {
        height: 413px;
        margin-right: -124px;
        margin-top: 48px;
    }

    .banner-text1 {
        color: var(--Color-Neutral-neutral-11, #323335);
        font-size: 36px;
        font-style: normal;
        font-weight: 600;
        line-height: 70px;
        text-align: left;
        white-space: nowrap;

    }

    .banner-text2 {
        color: var(--Color-Neutral-neutral-10, #64666B);
        text-align: center;

        font-size: 18px;
        font-style: normal;
        font-weight: 400;
        line-height: 22px;
        text-align: left
    }


}

.news {
    z-index: 2 !important;
    position: absolute;
    left: 50%;
    bottom: -36px;
    /* 水平居中，先移动到父元素宽度的中点 */
    transform: translate(-50%);
    /* 然后通过 transform 反向移动自身宽度和高度的一半 */
    /* 其他样式 */
    width: 1200px;
    height: 72px;

    display: flex;
    align-items: center;
    justify-content: space-between;


    border-radius: var(--Radius-Border-radius-3, 4px);
    border: var(--Radius-Border-radius-2, 2px) solid #FFF;
    background: linear-gradient(0deg, #FFF 0%, #F3F5F8 100%);
    box-shadow: 8px 8px 20px 0px rgba(55, 99, 170, 0.10);



    .news-text {
        margin-left: 16px;
        color: var(--Color-Neutral-neutral-11, #323335);

        font-size: 16px;
        font-style: normal;
        font-weight: 500;
        line-height: 24px;
        max-width: 650px;
        white-space: nowrap;
        /* 保持文本在一行内 */
        overflow: hidden;
        /* 隐藏超出容器的文本 */
        text-overflow: ellipsis;
        /* 用省略号表示被截断的文本 */
        cursor: pointer;
    }

    .news-time {

        font-size: 16px;
        font-style: normal;
        font-weight: 400;
        height: 72px;
        line-height: 72px;
        color: var(--Color-Neutral-neutral-10, #64666B);


    }

    .tomore {
        color: var(--Color-Branding-blue, #3461FF);

        font-size: 16px;
        font-style: normal;
        font-weight: 400;
        height: 72px;
        line-height: 72px;
        margin: 0 50px 0 10px;
        cursor: pointer;

    }


}

.titleBox {
    width: 400px;
    text-align: left;
    margin: 0 auto;
    margin-top: 100px;
}








.box2 {
    width: 100%;
    height: 370px;
    background: url('../assets/img/banner/search.webp') no-repeat center center;
    background-size: 100% 100%;
    padding: 1px;


    .center {
        width: 1200px;
        height: 168px;
        margin: 0 auto;
        display: flex;
        justify-content: space-between;
        margin-top: 40px;

        .textbox {
            width: 592px;
            height: 168px;
            padding: 24px;
            color: var(--Text-neutral-10, var(--Text-Text-10, #64666B));
            font-size: 16px;
            font-style: normal;
            font-weight: 400;
            line-height: 24px;
            border-radius: var(--Radius-Border-radius-3, 4px);
            background: linear-gradient(0deg, #FFF 0%, #F3F5F8 100%);
            box-shadow: 8px 8px 20px 0px rgba(55, 99, 170, 0.10);
            box-sizing: border-box;
            position: relative;

            .textico {
                position: absolute;
                left: 15px;
                top: 7px;
                width: 57px;
                height: 46px;

            }

            .text-item {
                position: absolute;
                left: 24px;
                top: 24px;
                width: 544px;

            }
        }

    }










}

.box3 {
    width: 100%;
    height: 670px;
    position: relative;
    padding: 1px 0 0 0;
    overflow: hidden;




}

.numtitle {
    /* width: 400px; */
    position: absolute;
    left: 50%;
    top: 88px;
    transform: translate(-50%);


}

.numtitle-text {
    color: #4198F5;
    text-align: center;

    font-size: 20px;
    font-style: normal;
    font-weight: 400;
    line-height: normal;
    position: absolute;
    left: 50%;
    top: 150px;
    transform: translate(-50%);
}



.num-row1 {
    position: absolute;
    top: 40%;
    left: 50%;
    transform: translate(-50%);
    display: flex;
    justify-content: space-between;
    width: 650px;
}

.num-row2 {
    position: absolute;
    display: flex;
    top: 60%;
    width: 1050px;
    left: 50%;
    transform: translate(-50%);
    justify-content: space-between;
}

.num-row3 {
    position: absolute;
    top: 72%;
    left: 50%;
    transform: translate(-50%);
    width: 320px;
    display: flex;
    justify-content: space-between;

}


.num-item {
    display: flex;
    flex-direction: column;
    align-items: center;
}

.num-container {
    width: 96px;
    height: 96px;
    background: url('../assets/img/Container.png') no-repeat center center;
    background-size: 100% 100%;
    position: relative;

    .num {
        width: 96px;
        height: 96px;
        color: var(--Color-Branding-branding-5, #4382FE);

        font-size: 36px;
        font-style: normal;
        font-weight: 700;
        line-height: 85px;
        position: absolute;
        top: 50%;
        transform: translate(0, -50%);
        text-align: center;
        margin-left: -3px;
    }


}



.num-row-text {
    color: #16181A;
    text-align: center;

    font-size: 18px;
    font-style: normal;
    font-weight: 600;
    line-height: 38px;
}


.box0 {
    width: 100%;
    height: 490px;
    background: #FFF;
    padding: 88px 0 0 0;



    .center {
        width: 1200px;
        height: 490px;
        margin: 0 auto;
        display: flex;

        .filebox {
            width: 100%;
            display: flex;
            justify-content: space-between;
        }

        .filebox-item {
            width: 580px;
            height: 220px;
            border-radius: var(--Radius-Border-radius-3, 4px);
            border: var(--Radius-Border-radius-2, 2px) solid #FFF;
            background: linear-gradient(0deg, #FFF 0%, #F3F5F8 100%);
            box-shadow: 8px 8px 20px 0px rgba(55, 99, 170, 0.10), -8px -8px 20px 0px #FFF;
            display: flex;
            padding: 22px 22px 34px 22px;
            box-sizing: border-box;

            .fileImg {
                width: 120px;
                height: 160px;
            }

            .fileContent {
                margin-left: 20px;

                .fileTitle {
                    margin-top: 10px;
                    color: #16181A;
                    font-size: 18px;
                    font-style: normal;
                    font-weight: 500;
                    line-height: 26px;
                }

                .fileText {
                    color: var(--Text-neutral-10, var(--Text-Text-10, #64666B));

                    font-size: 14px;
                    height: 66px;
                    font-style: normal;
                    font-weight: 400;
                    line-height: 22px;
                    margin-top: 12px;
                }

                .tofile {
                    margin-top: 21px;
                    color: var(--Blue-blue-6, var(--Branding-Blue-6, #3461FF));

                    font-size: 14px;
                    font-style: normal;
                    font-weight: 400;
                    line-height: 22px;
                    text-decoration-line: underline;
                    cursor: pointer;
                }
            }
        }





    }


}

.box1 {
    width: 100%;
    height: 820px;
    background: var(--Text-Text-3, #F8F8F9);
    padding: 1px;


    .bigcenter {
        width: 1225px;
        margin: 0 auto;
    }

    .center {
        width: 1200px;
        margin: 0 auto;
        display: flex;
        // overflow: hidden;
        height: 590px;
        margin-top: 40px;
        position: relative;

        .stepBox {
            width: 100%;
            display: flex;
            align-items: center;
            position: relative;
            transition: transform 0.3s ease;

            .step {
                position: relative;
                // height: 12px;
            }

            .stepLine1 {
                width: 114px;
                height: 4px;
                background: #D6DBE3;
            }

            .year {
                color: var(--Blue-blue-8, var(--Branding-Blue-6, #3461FF));
                text-align: center;
                font-size: 14px;
                font-style: normal;
                font-weight: 600;
                line-height: 22px;
                position: absolute;
                top: -30px;
                left: 50%;
                transform: translateX(-50%);
            }


            .yearInfoBox {
                position: absolute;
                top: -225px;
                width: 256px;
                left: 50%;
                transform: translateX(-50%);

                .title {
                    color: #16181A;
                    text-align: center;

                    font-size: 18px;
                    font-style: normal;
                    font-weight: 600;
                    line-height: 26px;
                    // width: 70%;
                    margin: 0 auto;
                    white-space: pre-line;
                }

                .text {
                    color: var(--Text-neutral-10, var(--Text-Text-10, #64666B));

                    font-size: 14px;
                    font-style: normal;
                    font-weight: 400;
                    line-height: 22px;
                    // padding: 0 8px;
                    margin-top: 8px;

                }
            }

            .yearInfoBox2 {
                position: absolute;
                top: 53px;
                width: 260px;
                left: 50%;
                transform: translateX(-50%);

                .title {
                    color: #16181A;
                    text-align: center;

                    font-size: 18px;
                    font-style: normal;
                    font-weight: 600;
                    line-height: 26px;
                    width: 255px;
                    margin: 0 auto;
                    // margin-left: 7px;
                    white-space: pre-line;
                }

                .text {
                    color: var(--Text-neutral-10, var(--Text-Text-10, #64666B));

                    font-size: 14px;
                    font-style: normal;
                    font-weight: 400;
                    line-height: 22px;
                    // padding: 0 8px;
                    margin-top: 8px;

                }
            }

            .nowStep {
                position: absolute;
                // top: -50px;
                left: 50%;
                transform: translateX(-50%);

            }

            .stepLine2 {
                width: 138px;
                height: 4px;
            }



        }

    }
}

.steppoint2 {
    // position: absolute;
    // top: 30px;
    // left: 50%;
    // transform: translateX(-50%);
    display: flex;

}

.file-img {
    width: 239px;
    height: 254px;
    border-radius: 5px;
}

.file-img2 {
    width: 240px;
    height: 100px;
    margin-top: 3px;
}

.file-img-box {
    display: flex;
    flex-direction: column;
    margin-top: -60px;
}

.newszmd {
    display: flex;
    align-items: center;
    justify-content: space-between;
    line-height: 72px;
}

.news-ico {
    width: 26px;
    height: 24px;
    margin-left: 50px;
}

.news-ico-text {
    color: var(--Color-Branding-blue, #3461FF);

    font-size: 18px;
    font-style: normal;
    font-weight: 600;
    line-height: 24px;
    margin-left: 9px;
}


.video-background {

    width: auto;
    // height: auto;
    height: 670px;
    // z-index: -100;
    /* 将视频背景置于其他内容之下 */
    // background: url('your-video.mp4') no-repeat; /* 备用图片（非所有浏览器都支持视频作为背景） */  
    background-size: contain;
    /* 覆盖整个背景 */
}

.video-background video {
    /* 确保视频覆盖整个背景区域 */
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    min-width: 100%;
    min-height: 100%;
    width: auto;
    height: auto;
    z-index: -100;
    /* 置于内容之下 */
    background: transparent;
    /* 视频播放后隐藏占位符 */
}

.infotextbox {
    width: 1250px;

}


.button1 {

    width: 170px;
    height: 48px;
    color: var(--Color-Neutral-neutral-1, #FFF);
    text-align: center;
    border-radius: 4px;

    font-size: 18px;
    font-style: normal;
    font-weight: 600;
    line-height: 48px;
    margin-top: 52px;
    border: 1px solid #FFF;
    cursor: pointer;
}


.button1:hover {
    color: var(--Color-Branding-blue, #3461FF);
    background: var(--Color-Neutral-neutral-1, #FFF);
}



.delStep {
    color: #97A3B7;
    width: 34px;
    height: 34px;
    padding: 7px;
    border-radius: 17px;
    border: var(--Radius-Border-radius-2, 2px) solid #FFF;
    background: linear-gradient(0deg, #FFF 0%, #F3F5F8 100%);
    box-shadow: 8px 8px 20px 0px rgba(55, 99, 170, 0.10), -8px -8px 20px 0px rgba(255, 255, 255, 0.80);
    box-sizing: border-box;
    cursor: pointer;
    display: flex;
}

.timeandmore {
    display: flex;
    align-items: center;
}

.box1 .center .stepBox:nth-child(6) .yearInfoBox .title {
    width: 100%;
}

section {
    padding: 64px 0;
    background-color: #ffffff;

    li {
        list-style: none;
    }

    &.gray {
        background-color: #f8f8f9;
    }

    &>main {
        width: 1200px;
        margin: 72px auto 0;
    }

    .use-case {
        position: relative;
        height: 396px;
        background: url("../assets/img/standard/use-case-bg.png") no-repeat top center/793.5px 590.85px;
        margin: 45px auto -64px;

        li {
            position: absolute;
            display: flex;
            align-items: center;
            width: 325px;
            height: 86px;
            border-radius: 12px;
            border: 3px solid #F4F4F5;
            box-shadow: 11.48px 11.48px 28.69px 0px rgba(55, 99, 170, 0.1);
            background-color: #FFFFFF;
            font-size: 22px;
            color: #323335;
            font-weight: 500;

            img {
                // width: 86px;
                // height: 86px;
                width: 52px;
                height: 52px;
                margin-right: 6px;
                margin-left: 25px;
            }

            &:nth-child(1) {
                top: 34px;
                left: 138px;
            }

            &:nth-child(2) {
                top: 34px;
                right: 138px;
            }

            &:nth-child(3) {
                top: 170px;
                left: 78px;
            }

            &:nth-child(4) {
                top: 170px;
                right: 78px;
            }
        }
    }

    .share-ideas {
        display: flex;
        justify-content: space-between;
        background: url('../assets/img/standard/china-map.png') no-repeat bottom -28px left 327px/519px 398px;

        .share-card {
            width: 360px;
            border-radius: 8px;
            overflow: hidden;

            h3 {
                font-size: 20px;
                font-weight: 600;
                line-height: 64px;
                text-align: center;
                background-color: #3461FF;
                color: #ffffff;
            }

            .card-main {
                box-sizing: border-box;
                padding-bottom: 16px;
                border: 1px solid #F4F4F5;
                border-top: 0;
            }

            .idea-item {
                padding: 24px 22px 0;
                font-size: 14px;
                font-weight: 400;
                line-height: 22px;
                color: #666666;

                b {
                    font-weight: 600;
                }



                .idea-title {
                    display: flex;
                    align-items: center;
                    font-size: 18px;
                    font-weight: 500;
                    color: #323335;

                    img {
                        width: 48px;
                        height: 48px;
                        margin-right: 16px;
                    }
                }
            }
        }
    }

    .list-main {
        display: flex;
        flex-wrap: wrap;
        margin-bottom: -24px;

        &>div {
            margin-right: 16px;
            margin-bottom: 24px;

            &:nth-child(3n) {
                margin-right: 0;
            }
        }
    }

    .principle-main {
        position: relative;

        ul {
            display: flex;
        }

        .arrow {
            position: absolute;
            top: 50%;
            transform: translateY(-50%);
            width: 34px;
            height: 34px;
            border-radius: 50%;
            border: 2px solid #FFFFFF;
            background: url('~@/assets/img/standard/arrow-left.png') no-repeat center/7.78px 12.73px, #F3F5F8;
            box-sizing: border-box;
            cursor: pointer;
            box-shadow: -8px -8px 20px 0px rgba(255, 255, 255, 0.8), 8px 8px 20px 0px rgba(55, 99, 170, 0.1);

            &-left {
                left: -50px;
            }

            &-right {
                right: -50px;
                background: url('~@/assets/img/standard/arrow-right.png') no-repeat center center/7.78px 12.73px, #F3F5F8;
            }
        }

        .principle-item {
            flex-shrink: 0;
            width: 388px;
            height: 238px;
            margin-right: 16px;
            border-radius: 8px;
            border: 2px solid #F4F4F5;
            background: url('~@/assets/img/standard/carousel-1.png') no-repeat top 37px right 18px/97px 91px, #ffffff;
            padding: 47px 24px 0;
            box-sizing: border-box;

            &:nth-child(2) {
                background: url('~@/assets/img/standard/carousel-2.png') no-repeat top 37px right 18px/97px 91px, #ffffff;
            }

            &:nth-child(3) {
                background: url('~@/assets/img/standard/carousel-3.png') no-repeat top 37px right 18px/97px 91px, #ffffff;
            }

            &:nth-child(4) {
                background: url('~@/assets/img/standard/carousel-4.png') no-repeat top 37px right 18px/97px 91px, #ffffff;
            }

            &:nth-child(5) {
                background: url('~@/assets/img/standard/carousel-5.png') no-repeat top 37px right 18px/97px 91px, #ffffff;
            }

            &:hover {
                box-shadow: 8px 8px 20px 0px rgba(55, 99, 170, 0.1);
            }

            h3 {
                font-size: 18px;
                font-weight: 600;
                line-height: 22px;
                color: #323335;
                margin-bottom: 16px;
            }

            p {
                font-size: 16px;
                font-weight: 400;
                line-height: 24px;
                color: #525760;
            }
        }

        .principle-item:hover {


            background: url('~@/assets/img/standard/carousel-1.png') no-repeat top 37px right 18px/97px 91px, linear-gradient(180deg, #F3F5F8 0%, #FFF 100%);

            &:nth-child(2) {
                background: url('~@/assets/img/standard/carousel-2.png') no-repeat top 37px right 18px/97px 91px, linear-gradient(180deg, #F3F5F8 0%, #FFF 100%);
            }

            &:nth-child(3) {
                background: url('~@/assets/img/standard/carousel-3.png') no-repeat top 37px right 18px/97px 91px, linear-gradient(180deg, #F3F5F8 0%, #FFF 100%);
            }

            &:nth-child(4) {
                background: url('~@/assets/img/standard/carousel-4.png') no-repeat top 37px right 18px/97px 91px, linear-gradient(180deg, #F3F5F8 0%, #FFF 100%);
            }

            &:nth-child(5) {
                background: url('~@/assets/img/standard/carousel-5.png') no-repeat top 37px right 18px/97px 91px, linear-gradient(180deg, #F3F5F8 0%, #FFF 100%);
            }


        }
    }

    .weight-text {
        color: var(--Text-neutral-11, #323335);

        font-size: 14px;
        font-style: normal;
        font-weight: 600;
        line-height: 22px;
    }
}
</style>